export default function UmbrellaLogo({ size = 100, className = '' }) {
  const r = 45;
  const cx = 50;
  const cy = 50;
  const angles = [0, 45, 90, 135, 180, 225, 270, 315];
  const colors = ['#cc0000', '#ffffff', '#cc0000', '#ffffff', '#cc0000', '#ffffff', '#cc0000', '#ffffff'];

  const getPoint = (angle) => ({
    x: cx + r * Math.sin((angle * Math.PI) / 180),
    y: cy - r * Math.cos((angle * Math.PI) / 180),
  });

  const segments = angles.map((angle, i) => {
    const start = getPoint(angle);
    const end = getPoint(angle + 45);
    return (
      <path
        key={i}
        d={`M${cx},${cy} L${start.x.toFixed(2)},${start.y.toFixed(2)} A${r},${r} 0 0,1 ${end.x.toFixed(2)},${end.y.toFixed(2)} Z`}
        fill={colors[i]}
      />
    );
  });

  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      data-testid="umbrella-logo"
    >
      <circle cx={cx} cy={cy} r={r + 2} fill="none" stroke="rgba(204,0,0,0.3)" strokeWidth="1" />
      {segments}
      <circle cx={cx} cy={cy} r={6} fill="#0a0a0a" />
      <circle cx={cx} cy={cy} r={4} fill="#cc0000" />
    </svg>
  );
}
